/**
 *Created by jmmartinez on 18/03/19
 *  v 1.1 08/11/2019 Eliminado botón volver
 *  v 1.2 24/04/2020 Añadido onFileUploaded en propTypes
 *  v 1.3 05/05/2020 Añadida función eliminarFileDeAcceptedFiles
 *  v.2.0 30/09/2020 Cambiado a framework2
 *  v.2.1 05/04/2021 Simplificacion.
 *                   Envío directo.
 *                   Soporte de imagenes, pdf, xls, xlsx, ods.
 *  v.2.2 18/07/2025 Añadida propiedad mostrarEnviar
 */

import React from 'react'
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone'
import {Container, Col, Row} from 'react-grid-system';
import {Button, ProgressBar, Intent, Icon, InputGroup, Card, Elevation} from "@blueprintjs/core";
import {posPrimerElementoConValorPropiedad, delPosicion} from "../utils/ArrayUtils"


const baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 200,
    height: 200,
    padding: 4,
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};


const titulo= "Arrastre un fichero aquí o haga Click para seleccionar. Formatos soportados: jpg, png, pdf, ods" ;

class FileUploader extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            imagen: null,
            acceptedFiles: [],
            progreso: 0,
            descripcion: ""
        }
    }

    onAcceptFiles= (acceptedFiles) => {
        let acceptedFilesConPreviews= acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        }));
        this.setState({
            acceptedFiles: acceptedFilesConPreviews,
            descripcion: "",   // 👈 importante
            progreso: 0
        });
    }

    enviar= () => {
        const {acceptedFiles, descripcion} = this.state;
        const {url} = this.props;
        console.log("ENVIAR:")
        console.log("files: ", acceptedFiles[0]);
        console.log("descripcion: ", descripcion);
        console.log("url: ", url);

        if (acceptedFiles.length === 0)
            return;

        if (!descripcion || descripcion.trim() === "") {
            alert("Debes introducir una descripción");
            return;
        }

        this.sendRequest(url, acceptedFiles[0]);
    }

    fileUploaded= (file) => {
        const {onFileUploaded} = this.props;
        console.log("fileUploaded");
        console.log("file: ", file);
        this.eliminarFileDeAcceptedFiles(file);
        onFileUploaded && onFileUploaded(file);
    }

    eliminarFileDeAcceptedFiles= (file) => {
        const {acceptedFiles} = this.state;
        let pos= posPrimerElementoConValorPropiedad(acceptedFiles, "name", file.name);
        console.log("Pos: " + pos);
        if (pos >= 0){
            let newAcceptedFiles = [...acceptedFiles];
            newAcceptedFiles.splice(pos, 1);
            this.setState({ acceptedFiles: newAcceptedFiles });
        }
    }

    fileError= () => {
        const {onFileError} = this.props;
        onFileError && onFileError();
    }



    sendRequest(url, file) {
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            //req.setRequestHeader()

            req.upload.addEventListener("progress", event => {
                let progreso= (event.loaded / event.total) * 100;
                console.log("PROGRESO");
                console.log(progreso);
                this.setState({ progreso: progreso});
            });

            req.addEventListener("load", () => {
                console.log("LOAD (respuesta servidor)");

                if (req.status >= 200 && req.status < 300) {
                    this.setState({ progreso: 100 });
                    resolve(req.response);
                    this.fileUploaded(file);
                } else {
                    reject(req.response);
                    this.fileError();
                }
            });


            req.upload.addEventListener("error", event => {
                console.log("ERROR");
                reject(req.response);
                this.fileError();
            });

            req.addEventListener("error", () => {
                console.log("ERROR DE RED");
                this.fileError();
            });

            const formData = new FormData();

            formData.append("file", file, file.name);
            formData.append("descripcion", this.state.descripcion);
            req.open("POST", url);
            req.send(formData);
        });
    }

    renderOld() {
        //accept={['image/*', 'application/pdf', 'application/vnd.oasis.opendocument.spreadsheet',
        //                           'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}>
        const { acceptedFiles} = this.state;
        const { mostrarEnviar, acceptTypes} = this.props;
        return (
            <>
                <Dropzone onDrop={this.onAcceptFiles} disabled={false} multiple={false}
                        accept={acceptTypes}>
                    {({isDragAccept, isDragActive, isDragReject, getRootProps, getInputProps}) => {
                        let borderColor= '#eeeeee';
                        if (isDragAccept)
                            borderColor= '#00ff00';
                        if (isDragReject)
                            borderColor= '#ff0000';
                        return (
                            <Container  fluid={true}>
                                <Row>
                                    <Col md={4}>
                                        <section style={ {...baseStyle, borderColor}}>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <p>{titulo}</p>
                                            </div>
                                        </section>
                                    </Col>
                                </Row>
                            </Container>
                        )
                        }
                    }
                </Dropzone>
                {acceptedFiles.length > 0 && (
                        <div style={{ marginTop: 10 }}> <Icon icon="document" /> <span style={{ marginLeft: 5 }}> {acceptedFiles[0].name}</span>  </div>
                )}

                <InputGroup
                    placeholder="Descripción"
                    value={this.state.descripcion}
                    onChange={(e) => this.setState({ descripcion: e.target.value })}
                />

                {Boolean(mostrarEnviar) &&
                <div className="botonera">
                    {acceptedFiles.length > 0 &&
                        <Button icon="saved" className="boton" onClick={this.enviar}>Enviar</Button>
                    }
                </div>
                }
            </>
        )
    }

    render() {
        const { acceptedFiles, descripcion, progreso } = this.state;
        const { mostrarEnviar, acceptTypes } = this.props;

        const hasFile = acceptedFiles.length > 0;

        return (
            <Card elevation={Elevation.TWO} style={{ maxWidth: 500, margin: "20px auto", padding: 20 }}>

                {/* DROPZONE */}
                <Dropzone onDrop={this.onAcceptFiles} multiple={false} accept={acceptTypes}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div
                            {...getRootProps()}
                            style={{
                                ...baseStyle,
                                width: "100%",
                                height: 150,
                                borderColor: isDragActive ? "#137cbd" : "#d8e1e8",
                                cursor: "pointer"
                            }}
                        >
                            <input {...getInputProps()} />
                            <Icon icon="upload" size={30} />
                            <p style={{ marginTop: 10, textAlign: "center" }}>
                                {titulo}
                            </p>
                        </div>
                    )}
                </Dropzone>

                {/* ARCHIVO SELECCIONADO */}
                {hasFile && (
                    <div style={{ marginTop: 15, display: "flex", alignItems: "center" }}>
                        <Icon icon="document" />
                        <span style={{ marginLeft: 8, fontWeight: 500 }}>
                        {acceptedFiles[0].name}
                    </span>
                    </div>
                )}

                {/* INPUT DESCRIPCIÓN */}
                {hasFile && (
                    <div style={{ marginTop: 15 }}>
                        <InputGroup
                            placeholder="Descripción del archivo"
                            value={descripcion}
                            onChange={(e) => this.setState({ descripcion: e.target.value })}
                            fill
                        />
                    </div>
                )}

                {/* PROGRESO */}
                {progreso > 0 && (
                    <div style={{ marginTop: 15 }}>
                        <ProgressBar value={progreso / 100} />
                    </div>
                )}

                {/* BOTÓN */}
                {Boolean(mostrarEnviar) && hasFile && (
                    <div style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            intent={Intent.PRIMARY}
                            icon="upload"
                            onClick={this.enviar}
                            disabled={!descripcion || descripcion.trim() === ""}
                        >
                            Enviar
                        </Button>
                    </div>
                )}
            </Card>
        );
    }

}


FileUploader.propTypes = {
    url: PropTypes.string,
    acceptTypes: PropTypes.array,
    onFileUploaded: PropTypes.func,
    onFileError: PropTypes.func,
    mostrarEnviar: PropTypes.bool,
}

export default FileUploader;